<template>
    <ns-modal v-model="dialog" :title="txc.add_bank_account" :fullscreen="fullscreen" @input="closeDialog">
        <server-error v-if="!!dialogError" :error="dialogError"/>
        <v-form ref="directDepositFormCA" v-model="addBankAccountFormCA" @submit.prevent>
            <p>{{txc.direct_deposit_explanation}}</p>
            <div data-test-id="directDepositNameAcct" class="field-label">{{txc.direct_deposit_name_acct}}</div>
            <v-text-field data-test-id="name" v-model="name" readonly/>
            <div data-test-id="bankName" class="field-label">{{txc.ca_bank_name}}</div>
            <v-select
                :items="bankNames"
                item-text="name"
                item-value="number"
                v-model="bankName"
                data-test-id="bankName"
            />
            <div data-test-id="bankTransit" class="field-label">{{txc.ca_branch_transit}}</div>
            <v-text-field data-test-id="branchNumber" v-model="branchNumber" pattern="[0-9]*" mask="#####" required/>
            <div class="field-hint mb-3">
                <a href="#" @click.stop="toggleStub('dd-ca-branch')">{{txc.hint_text}}</a>
            </div>
            <div id="dd-ca-branch" class="fancyTooltip hidden">
                <div class="clickable text-right" @click.stop="toggleStub('dd-ca-branch')">&times;</div>
                <p>{{txc.hint_content}}</p>
                <div id="dd-ca-branchimg" class="checkImage">
                    &nbsp;
                </div>
            </div>
            <div data-test-id="accountNumber" class="field-label">{{txc.account_number}}</div>
            <v-text-field data-test-id="accountNumber" v-model="accountNumber" pattern="[0-9]*" required/>
            <div class="field-hint mb-3">
                <a href="#" @click.stop="toggleStub('dd-ca-acct')">{{txc.hint_text}}</a>
            </div>
            <div id="dd-ca-acct" class="fancyTooltip hidden">
                <div class="clickable text-right" @click.stop="toggleStub('dd-ca-acct')">&times;</div>
                <p>{{txc.hint_content}}</p>
                <div id="dd-ca-acctimg" class="checkImage">
                    &nbsp;
                </div>
            </div>
            <v-checkbox :rules="[ruleSet.required]">
                <template v-slot:label>
                    <span class="terms-text" data-test-id="agreeToTerms" v-html="ddAgreementTerms.terms_text"></span>
                </template>
            </v-checkbox>
        </v-form>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        :disabled="!addBankAccountFormCA"
                        @click="submitBankInfoCA"
                        data-test-id="save"
                    >{{txcg.save}}
                    </button>
                </v-flex>
                <v-spacer/>
                <v-flex xs12>
                    <button
                        flat
                        outline
                        block
                        class="secondary-hit fluid"
                        @click="closeDialog"
                        data-test-id="cancel"
                    >{{txcg.cancel}}
                    </button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import * as ruleSet from '../../repositories/globalRules.js';
import {ProfileService} from '@nuskin/ns-account';
import { mapGetters, mapActions } from 'vuex'

import { NsModal } from '@nuskin/design-components';
import ServerError from '../ServerError';
import profileUtils from '../../repositories/profileUtils';

export default {
    components: {
        NsModal,
        ServerError
    },
    data() {
        return {
            ruleSet,
            dialog: true,
            dialogError: null,
            addBankAccountFormCA:{},
            bankNames: [],
            name:'',
            accountType:'',
            routingNumber:'',
            accountNumber:'',
            rules: {
                required: ruleSet.required
            }
        }
    },
    computed: {
        ...mapGetters({
            txc: 'translationsDirectDeposit',
            txcg: 'translationsGlobal',
            txce: 'translationsError',
            fullscreen:'mobileView',
            localName:'localName',
            account: 'account',
            translationsTerms: 'translationsTerms',
            ddAgreementTerms: 'directDepositAgreementTerms'
        })
    },
    methods:{
        ...mapActions([ 'setAccount' ]),
        toggleStub(id) {
            let divID = document.getElementById(id);
            divID.classList.toggle('hidden');
            profileUtils.publishAnalytics(this.$analytics.category.deposits, 'CA_bank_account', '$(id)_help_link');
        },
        closeDialog(){
            this.$emit('closeDialog');
            this.dialogError = null;
        },
        getBankList() {
            let self = this;
            ProfileService.getAvailableBanksForMarket('CA').then(function (response) {
                self.bankNames = response;
                self.bankNames.sort((a, b) => (a.name > b.name) ? 1 : -1);
            })
        },
        submitBankInfoCA() {
            let bankData = {
                accountName: this.name,
                accountNumber: this.accountNumber,
                routingNumber: this.bankName,
                branchNumber: this.branchNumber
            };
            ProfileService.updateBankInfo(bankData)
                .then(response => {
                    if (response) {
                        this.$emit('bankAccountAdded')
                        profileUtils.publishAnalytics(
                            this.$analytics.category.deposits,
                            'CA_bank_account',
                            'added',
                            { email: this.account.email }
                        )
                    }
                })
                .catch((error) => {
                    /* @todo - sorting through and adding translations 
                    for each possible error code is going to be a deeper dive */
                    this.dialogError = {
                        message:'Undefined Error'
                    }
                })
        }
    },
    created() {
        this.name = this.localName ;
        this.getBankList();
        profileUtils.publishAnalytics(this.$analytics.category.deposits, 'CA_bank_account_dialog', 'opened');
    },
    destroyed() {
        profileUtils.publishAnalytics(this.$analytics.category.deposits, 'CA_bank_account_dialog', 'closed');
    }
}
</script>
<style scoped lang="scss">
    @use "sass:map";
    @use "~@nuskin/ns-core-styles/src/scss/global.mixins";
    .terms-text {
       @include global.paragraph-m();
    }
</style>
